import { useState, useEffect } from 'react';
import { fetchGeoData, type GeoData } from '../geo';

interface GeoState extends GeoData {
  loading: boolean;
  error: string | null;
}

export function useGeolocation(): GeoState {
  const [geoData, setGeoData] = useState<GeoState>({
    country: '',
    countryCode: '',
    region: '',
    city: '',
    timezone: '',
    currency: 'EUR',
    isEU: false,
    loading: true,
    error: null,
  });

  useEffect(() => {
    const fetchGeolocation = async () => {
      try {
        const data = await fetchGeoData();
        setGeoData({ ...data, loading: false, error: null });
      } catch (error) {
        console.error('Geolocation error:', error);
        setGeoData(prev => ({
          ...prev,
          isEU: true,
          loading: false,
          error: 'Failed to detect location',
        }));
      }
    };

    fetchGeolocation();
  }, []);

  return geoData;
}
